/* ===========================
 * Wallet Order Transformer
 * ===========================
 *
 * The transformer for the patient profile
 */

import Transformer from './transformer';
import isNil from 'lodash/isNil';

export default class WalletOrderTransformer extends Transformer {
  /**
   * Method used to transform a fetched profile
   *
   * @param wallet The fetched wallet order
   *
   * @returns {Object} The transformed profile
   */
  static fetchForTable(wallet) {
    return {
      patient_support_pin: wallet.user ? wallet.user.support_pin : '',
      wallet_order_id: wallet.id,
      appointment_id: wallet.appointment_id,
      created_at: wallet.created_at,
      action: wallet.details.action ? `"${wallet.details.action}"` : '',
      method: wallet.details.method,
      amount: wallet.details.amount,
      payment_gateway_fee: !isNil(wallet.price_detail) ? wallet.price_detail.fee_gateway : '',
      vat: wallet.details.vat,
      total_amount: this.getTotalAmount(wallet),
      voucher_code: wallet.details.code,
      status: wallet.status,
      result_code_message: wallet.details.resultCode
        ? `${wallet.details.resultCode} ${
            wallet.details.resultMessage ? `"${wallet.details.resultMessage || ''}"` : ''
          }`
        : '',
    };
  }

  static getTotalAmount(wallet) {
    const { details, price_detail } = wallet;

    if (details.amount && !isNil(price_detail)) {
      return details.amount + price_detail.fee_gateway;
    } else if (details.amount) {
      return details.amount;
    } else {
      return 0;
    }
  }
}
